// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.helpLinks {\n    text-align: right;\n}\n\ndiv.helpLinks a {\n    margin: 10px;\n}\n\ndiv.ICIPBanner {\n    width: 100%;\n    background-color: lightgrey;\n    text-align: center;\n    margin-bottom: 1em;\n}\n\ndiv.ICIPBanner h1 {\n    padding: 0.6em;\n    color: black;\n}", ""]);
// Exports
module.exports = exports;
